import React, { useMemo } from 'react';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export interface SubmenuGroupWrapperProps<OptionType extends CascaderOption>
  extends InternalSubmenuGroupWrapperProps {
  getCommonProps: () => CascaderCommonProps<OptionType>;
}

interface InternalSubmenuGroupWrapperProps extends BoxProps {
  submenuGroupRef?: React.Ref<HTMLDivElement>;
}

export const InternalSubmenuGroupWrapper = <OptionType extends CascaderOption>({
  submenuGroupRef,
  children,
  ...rest
}: InternalSubmenuGroupWrapperProps) => {
  const { cascaderStyles, getCommonProps } = useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomSubmenuGroupWrapper = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.SUBMENU_GROUP_WRAPPER),
    [getComponent],
  );

  return (
    <CustomSubmenuGroupWrapper
      submenuGroupRef={submenuGroupRef}
      getCommonProps={getCommonProps}
      __css={cascaderStyles.submenuGroupWrapper}
      {...rest}
      className="cascader-submenu-group-wrapper"
    >
      {children}
    </CustomSubmenuGroupWrapper>
  );
};

export const SubmenuGroupWrapper = <OptionType extends CascaderOption>({
  submenuGroupRef,
  children,
  getCommonProps: _,
  ...rest
}: SubmenuGroupWrapperProps<OptionType>) => {
  return (
    <Box ref={submenuGroupRef} {...rest}>
      {children}
    </Box>
  );
};
